// 更新为Vue3的图标注册方式
import SvgIcon from '@/components/SvgIcon'

// 导入所有SVG图标
/* eslint-disable no-undef */
const svgRequire = require.context('./svg', false, /\.svg$/)
/* eslint-enable no-undef */
const requireAll = requireContext => requireContext.keys().map(requireContext)

export default (app) => {
  app.component('svg-icon', SvgIcon)
  
  try {
    // 尝试加载所有SVG
    requireAll(svgRequire)
    //console.log('SVG icons loaded successfully:', svgRequire.keys())
  } catch (error) {
    console.error('Failed to load SVG icons:', error)
  }
}
